import type { OnboardingRequirement } from '@onefootprint/request-types';

/**
 * Given the last top priority requirement and current top priority requirement, returns if the
 * user is stuck on a repeat requirement.
 */
const isRepeatRequirement = (a?: OnboardingRequirement, b?: OnboardingRequirement) => {
  if (!a || !b) {
    return false;
  }
  if (a.kind === 'sleep' && b.kind === 'sleep') {
    return false;
  }
  return requirementKey(a) === requirementKey(b);
};

export const requirementKey = (requirement: OnboardingRequirement) => {
  if (requirement.kind === 'collect_document') {
    if (requirement.config.kind === 'custom') {
      return `${requirement.kind}-${requirement.config.name}`;
    }
    return `${requirement.kind}-${requirement.config.kind}-${requirement.documentRequestId}`;
  }
  if (requirement.kind === 'collect_custom_data') {
    const dis = requirement.page.sections
      .filter(s => s.kind === 'prompt')
      .map(s => s.di)
      .join(',');
    return `${requirement.kind}-${dis}`;
  }
  if (requirement.kind === 'sleep') {
    // It's possible to have multiple sleep requirements in a row, we don't care if sleep requirements are repeated
    return `${requirement.kind}-${Date.now()}`;
  }
  if (requirement.kind === 'select_conditional_branch') {
    return `${requirement.kind}-${requirement.nodeName ?? ''}`;
  }
  return requirement.kind;
};

export default isRepeatRequirement;
